import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nouveau produit',
  fields: {
    type: {
      label: 'Type de produit',
      options: {
        [SubscriptionProductType.Plan]: 'Forfait',
        [SubscriptionProductType.AddOn]: 'Extension',
        [SubscriptionProductType.GoogleAdsPlan]: 'Forfait Google Ads',
      },
    },
    name: {
      label: 'Nom interne',
      placeholder: 'Saisir le nom interne du produit',
    },
    public_name: {
      label: 'Nom public',
      placeholder: 'Saisir le nom public du produit',
    },
    description: {
      label: 'Description',
    },
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  feedback: {
    missing_info: 'Informations manquantes',
  },
  toasts: {
    plan_got_created: 'Produit créé',
    plan_got_updated: 'Produit mis à jour',
  },
};
